// Copyright ©️ 2026 eVolve MEP, LLC

import { Navigate, Outlet, Route, Routes } from 'react-router';

import { useMaybeUser } from 'hooks/user/useMaybeUser';

import { AcceptInvitation } from './AcceptInvitation';
import { AuthPageLayout } from './components/AuthPageLayout';
import { ForgotPassword } from './ForgotPassword/ForgotPassword';
import { ssoAuthPath } from './Login/helper';
import { Login } from './Login/Login';
import { LoginMicrosoftSSO } from './Login/LoginMicrosoftSSO';
import { ResetPassword } from './ResetPassword';
import { VerifyEmailPrompt } from './VerifyEmailPrompt';

const SignedOutOnly = () => {
  const { user } = useMaybeUser();
  return user?.acceptedLatestEula ? <Navigate to="/" /> : <Outlet />;
};

export const AuthenticationRoutes = () => (
  <AuthPageLayout>
    <Routes>
      {/* The SSO callback decides for itself: a signed-in web user may be finishing a sign-in for a desktop app */}
      <Route path={ssoAuthPath} element={<LoginMicrosoftSSO />} />
      <Route element={<SignedOutOnly />}>
        <Route path="login" element={<Login />} />
        <Route path="forgot-password" element={<ForgotPassword />} />
        <Route path="password-reset" element={<ResetPassword />} />
        <Route path="email-confirmation" element={<VerifyEmailPrompt />} />
        <Route path="accept" element={<AcceptInvitation />} />
        <Route path="*" element={<Navigate to="login" />} />
      </Route>
    </Routes>
  </AuthPageLayout>
);
